import React, { PureComponent, createRef } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import Svg from "../../../common/svgIcon";
import Tooltip from "react-tooltip-lite";
import ExternalAccount from "../../../common/externalAccount/ExternalAccount";
import { Redirect } from "react-router-dom";
import { BookmakersSwitcher } from "../../BookmakersSwitcher";
import { setBookmakersOrder } from "../../../common/bookmakersInfo/bookmakersInfo.actions";
import { getExternalAccountUrl } from "../../../common/externalAccount/externalAccount.actions";
import { clearJustLoggedInBookmaker } from "../../../common/bookmakersList/bookmakersList.actions";
import { actions as popoverActions } from "../../../common/bookmakersListPopover";

export class SwitchBookmakerButtons extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			isLogoutBtnDisabled: false,
			isLoginTooltipActive: false,
			isDepositTooltipActive: false,
		};

		this.depositBtnRef = createRef();
		this.depositTooltipRef = createRef();
		this.loginTooltipRef = createRef();
		this.loginBtnRef = createRef();
	}

	toggleDepositTooltip = (isSkyBet) => {
		if (isSkyBet) {
			this.props.getExternalAccountUrl(this.props.apiName);
		}

		this.setState((prevState) => ({
			isDepositTooltipActive: !prevState.isDepositTooltipActive,
		}));
	};

	toggleLoginTooltip = () => {
		this.setState((prevState) => ({
			isLoginTooltipActive: !prevState.isLoginTooltipActive,
		}));
	};

	handleLogout = () => {
		this.props.onLogout();

		this.setState({
			isLogoutBtnDisabled: true,
		});
	};

	// eslint-disable-next-line consistent-return
	handleOutsideClick = (e) => {
		if (
			this.depositBtnRef &&
			this.depositBtnRef.current &&
			this.depositBtnRef.current.contains(e.target)
		) {
			return false;
		}

		if (
			this.depositTooltipRef &&
			this.depositTooltipRef.current &&
			!this.depositTooltipRef.current.contains(e.target)
		) {
			this.setState({
				isDepositTooltipActive: false,
			});
		}

		if (
			this.loginBtnRef &&
			this.loginBtnRef.current &&
			this.loginBtnRef.current.contains(e.target)
		) {
			return false;
		}

		if (
			this.loginTooltipRef &&
			this.loginTooltipRef.current &&
			!this.loginTooltipRef.current.contains(e.target)
		) {
			this.setState({
				isLoginTooltipActive: false,
			});
		}
	};

	componentDidMount = () => {
		this.setState({
			isLogoutBtnDisabled: false,
		});

		if (this.props.apiName === "skybet" && this.props.isLoggedIn) {
			this.props.getExternalAccountUrl(this.props.apiName);
		}

		document.addEventListener("mousedown", this.handleOutsideClick);
	};

	componentDidUpdate = (nextProps) => {
		if (!this.props.isLoginOpen && nextProps.isLoginOpen) {
			this.setState((prevProps) => ({
				...prevProps,
				isLoginTooltipActive: false,
			}));
		}
	};

	componentWillUnmount = () => {
		document.removeEventListener("mousedown", this.handleOutsideClick);
	};

	render() {
		const {
			isLoginLeftPositioned,
			feed,
			name,
			isLoggedIn,
			analyticsRegistrationClick,
			bookmakersList,
			activePopoverFeed,
			openLoginPopover,
			registrationOfferLinkUrl,
			withdrawBookmakerUrl,
			isWindowLogin,
			externalAccountUrl,
			isExternalAccountError,
			shouldShowSignUp,
		} = this.props;

		return (
			<React.Fragment>
				{isLoggedIn ? (
					<div
						className={"root__bookmakersContentRightLoggedIn"}
						data-test-selector={`Container__${name}__LoggedInBookmakerRightContent`}
					>
						{name === "skybet" ? (
							<React.Fragment>
								<div
									className={classNames(
										"root__bookmakersContentRightBtnDepositFunds",
										{
											root__bookmakersContentRightBtnDepositFundsActive:
												this.state.isDepositTooltipActive,
										}
									)}
									onClick={() => this.toggleDepositTooltip(true)}
									ref={this.depositTooltipRef}
									data-test-selector='Button__skybet__Deposit'
								>
									Deposit Funds
								</div>
								{this.state.isDepositTooltipActive && (
									<ExternalAccount
										type='window'
										windowName={"History"}
										externalAccountUrl={externalAccountUrl}
										isExternalAccountError={isExternalAccountError}
										onExternalBackButtonClick={() =>
											this.toggleDepositTooltip(false)
										}
									/>
								)}
							</React.Fragment>
						) : (
							<Tooltip
								content={
									<div
										ref={this.depositTooltipRef}
										data-test-selector={`Container__${name}__Deposit`}
									>
										<BookmakersSwitcher
											name={name}
											bookmakersList={bookmakersList}
											setBookmakersOrder={setBookmakersOrder}
											clearJustLoggedInBookmaker={clearJustLoggedInBookmaker}
											selectedBookmakerFeed={feed}
										>
											<Redirect to={{ pathname: `/${feed}/account/info` }} />
										</BookmakersSwitcher>
									</div>
								}
								direction='bottom'
								tagName='span'
								useHover={false}
								isOpen={this.state.isDepositTooltipActive}
							>
								<div
									className={classNames(
										"root__bookmakersContentRightBtnDepositFunds",
										{
											root__bookmakersContentRightBtnDepositFundsActive:
												this.state.isDepositTooltipActive,
										}
									)}
									onClick={this.toggleDepositTooltip}
									ref={this.depositBtnRef}
									data-test-selector={`Button__${name}__Deposit`}
								>
									Deposit Funds
								</div>
							</Tooltip>
						)}
						{/* current installed version of react-router-dom doesn't support <Link> to have _target=blank */}
						{withdrawBookmakerUrl && (
							<a
								href={withdrawBookmakerUrl}
								target='_blank'
								className='root__bookmakersContentRightBtnWithdrawFunds'
								data-test-selector={`Link__${name}__Withdraw`}
							>
								Withdraw Funds
							</a>
						)}
					</div>
				) : isWindowLogin ? (
					<React.Fragment>
						{this.state.isLoginTooltipActive && (
							<div
								ref={this.loginTooltipRef}
								data-test-selector={`Container__${name}__BookmakerLogin`}
							>
								<BookmakersSwitcher
									name={name}
									bookmakersList={bookmakersList}
									setBookmakersOrder={setBookmakersOrder}
									clearJustLoggedInBookmaker={clearJustLoggedInBookmaker}
									selectedBookmakerFeed={feed}
								>
									{activePopoverFeed === feed ? (
										<Redirect to={{ pathname: `/${feed}/login` }} />
									) : (
										"Unable to load bookmaker"
									)}
								</BookmakersSwitcher>
							</div>
						)}
						<div
							className={classNames("root__bookmakersContentRightBtnLogIn", {
								root__bookmakersContentRightBtnLogInActive:
									this.state.isLoginTooltipActive,
							})}
							onClick={() => {
								openLoginPopover(feed);
								this.toggleLoginTooltip();
							}}
							ref={this.loginBtnRef}
							data-test-selector={`Button__${name}__BookmakerLogin`}
						>
							LOG IN
						</div>
					</React.Fragment>
				) : (
					<Tooltip
						content={
							this.state.isLoginTooltipActive && (
								<div ref={this.loginTooltipRef}>
									<div
										className='root__bookmakersContentPopoverClose'
										onClick={this.toggleLoginTooltip}
										data-test-selector={`Button__${name}__ToggleBookmakerLoginTooltip`}
									>
										<Svg iconName='remove' size='small' />
									</div>
									<BookmakersSwitcher
										name={name}
										bookmakersList={bookmakersList}
										setBookmakersOrder={setBookmakersOrder}
										clearJustLoggedInBookmaker={clearJustLoggedInBookmaker}
										selectedBookmakerFeed={feed}
									>
										{activePopoverFeed === feed ? (
											<Redirect to={{ pathname: `/${feed}/login` }} />
										) : (
											"Unable to load bookmaker"
										)}
									</BookmakersSwitcher>
								</div>
							)
						}
						direction={isLoginLeftPositioned ? "left" : "right"}
						tagName='span'
						useHover={false}
						isOpen={this.state.isLoginTooltipActive}
						className={
							this.state.isLoginTooltipActive
								? "root__bookmakersContentTooltipWrapper"
								: ""
						}
					>
						<div
							className={classNames("root__bookmakersContentRightBtnLogIn", {
								root__bookmakersContentRightBtnLogInActive:
									this.state.isLoginTooltipActive,
							})}
							onClick={() => {
								openLoginPopover(feed);
								this.toggleLoginTooltip();
							}}
							ref={this.loginBtnRef}
							data-test-selector={`Button__${name}__BookmakerLogin`}
						>
							LOG IN
						</div>
					</Tooltip>
				)}
				{isLoggedIn ? (
					<button
						className={classNames("root__bookmakersContentRightBtnLogOut")}
						onClick={this.handleLogout}
						disabled={this.state.isLogoutBtnDisabled}
						data-test-selector={`Button__${name}__BookmakerLogout`}
					>
						<span>logout</span>
					</button>
				) : (
					shouldShowSignUp && (
						<a
							href={registrationOfferLinkUrl || withdrawBookmakerUrl}
							className='root__bookmakersContentRightBtnSignUp'
							target='_blank'
							onClick={analyticsRegistrationClick}
							data-test-selector={`Link__${name}__BookmakerSignUp`}
							rel='noreferrer nofollow sponsored'
						>
							sign up
						</a>
					)

				)}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state) => {
	const {
		bookmakersListPopover: { activePopoverFeed, activePopoverType },
		loginPage: { isLoginOpen },
		externalAccount: { externalAccountUrl, isExternalAccountError },
	} = state;

	return {
		isLoginOpen,
		activePopoverFeed,
		activePopoverType,
		externalAccountUrl,
		isExternalAccountError,
	};
};

const mapDispatchToProps = {
	closePopover: popoverActions.closeCurrentPopover(),
	openLoginPopover: (feed) => popoverActions.setActivePopoverWithTypeAndFeed("login", feed),
	getExternalAccountUrl,
};

export default connect(mapStateToProps, mapDispatchToProps)(SwitchBookmakerButtons);



// WEBPACK FOOTER //
// /src/js/bookmakersSwitcher/chooseBookmakerPage/components/SwitchBookmakerButtons.jsx